export interface SoleLink {
  href: string;
  /** Text from a markdown link, when it is different from the address. */
  label?: string;
}

const HTTP_URL = /^https?:\/\/\S+$/i;

/**
 * A support page whose whole content is a single web address. Surrounding
 * text, several links, or any other markdown means it is a real page.
 */
export const soleLink = (markdown: string | undefined): SoleLink | null => {
  const text = markdown?.trim() ?? '';
  if (!text || text.includes('\n')) return null;

  if (HTTP_URL.test(text)) {
    return { href: text };
  }

  const autolink = text.match(/^<(https?:\/\/[^>\s]+)>$/i);
  if (autolink?.[1]) {
    return { href: autolink[1] };
  }

  const markdownLink = text.match(
    /^\[([^\]\n]+)\]\((https?:\/\/[^)\s]+)(?:\s+"[^"]*")?\)$/i,
  );
  if (!markdownLink?.[1] || !markdownLink[2]) return null;

  const label = markdownLink[1].trim();
  const href = markdownLink[2];
  if (!label || label === href) return { href };
  return { href, label };
};
